export default {
  // 服务配置管理页面
  'pages.service-config.title': '金额配置',
  'pages.service-config.subTitle': '管理物业费用的收费项目和价格配置',
  'pages.service-config.breadcrumb.feeManagement': '收费管理',
  'pages.service-config.breadcrumb.moneyConfig': '金额配置',
  'pages.service-config.detail.title': '金额配置详情',

  // 列表页面
  'pages.service-config.table.title': '金额配置列表',
  'pages.service-config.table.create': '新建配置',
  'pages.service-config.table.batchDelete': '批量删除',
  'pages.service-config.table.confirmDelete': '确定要删除这条配置吗？',
  'pages.service-config.table.confirmBatchDelete': '确定要批量删除选中的配置吗？',
  'pages.service-config.table.deleteSuccess': '删除成功',
  'pages.service-config.table.deleteFailed': '删除失败',
  'pages.service-config.table.batchDeleteSuccess': '批量删除成功',
  'pages.service-config.table.batchDeleteFailed': '批量删除失败',
  'pages.service-config.table.getDetailFailed': '获取详情失败',
  'pages.service-config.table.createSuccess': '创建成功',
  'pages.service-config.table.updateSuccess': '更新成功',
  'pages.service-config.table.createFailed': '创建失败',
  'pages.service-config.table.updateFailed': '更新失败',
  'pages.service-config.table.submitFailed': '操作失败',
  'pages.service-config.table.selectedItems': '已选择',
  'pages.service-config.table.items': '项',
  'pages.service-config.table.cancelSelection': '取消选择',
  'pages.service-config.table.close': '关闭',

  // 表格列
  'pages.service-config.table.columns.feeType': '收费类型',
  'pages.service-config.table.columns.icon': '图标',
  'pages.service-config.table.columns.name': '服务名称',
  'pages.service-config.table.columns.introduction': '描述',
  'pages.service-config.table.columns.status': '状态',
  'pages.service-config.table.columns.batchCreate': '批量创建',
  'pages.service-config.table.columns.sort': '排序',
  'pages.service-config.table.columns.createdTime': '创建时间',
  'pages.service-config.table.columns.operations': '操作',
  'pages.service-config.table.columns.edit': '编辑',
  'pages.service-config.table.columns.delete': '删除',

  // 详情弹窗
  'pages.service-config.detail.modal.title': '配置详情',
  'pages.service-config.detail.feeType': '收费类型',
  'pages.service-config.detail.unitPrice': '单价',
  'pages.service-config.detail.unit': '单位',
  'pages.service-config.detail.billingCycle': '计费周期',
  'pages.service-config.detail.status': '状态',
  'pages.service-config.detail.batchCreate': '支持批量创建',
  'pages.service-config.detail.remarks': '备注',
  'pages.service-config.detail.createdTime': '创建时间',
  'pages.service-config.detail.updatedTime': '更新时间',
  'pages.service-config.detail.createdBy': '创建者',
  'pages.service-config.detail.updatedBy': '更新者',
  'pages.service-config.detail.yes': '是',
  'pages.service-config.detail.no': '否',

  // 表单
  'pages.service-config.form.editTitle': '编辑金额配置',
  'pages.service-config.form.createTitle': '新建金额配置',
  'pages.service-config.form.feeType.label': '收费类型',
  'pages.service-config.form.feeType.required': '请选择收费类型',
  'pages.service-config.form.feeType.placeholder': '请选择收费类型',
  'pages.service-config.form.icon.label': '图标',
  'pages.service-config.form.icon.required': '请选择图标',
  'pages.service-config.form.icon.placeholder': '请选择图标',
  'pages.service-config.form.name.label': '名称',
  'pages.service-config.form.name.required': '请输入名称',
  'pages.service-config.form.name.placeholder': '请输入配置名称',
  'pages.service-config.form.introduction.label': '介绍',
  'pages.service-config.form.introduction.required': '请输入介绍',
  'pages.service-config.form.introduction.placeholder': '请输入配置介绍',
  'pages.service-config.form.sort.label': '排序',
  'pages.service-config.form.sort.required': '请输入排序值',
  'pages.service-config.form.sort.placeholder': '请输入排序值',
  'pages.service-config.form.sort.min': '排序值必须大于等于0',
  'pages.service-config.form.status.label': '状态',
  'pages.service-config.form.status.required': '请选择状态',
  'pages.service-config.form.status.placeholder': '请选择状态',
  'pages.service-config.form.batchCreate.label': '是否支持批量创建',
  'pages.service-config.form.batchCreate.required': '请选择是否支持批量创建',
  'pages.service-config.form.select': '选择',
  'pages.service-config.form.emojiPicker.title': '选择表情图标',

  // 状态选项
  'pages.service-config.status.enabled': '启用',
  'pages.service-config.status.disabled': '禁用',
  'pages.service-config.status.unknown': '未知',

  // 批量创建选项
  'pages.service-config.batchCreate.yes': '是',
  'pages.service-config.batchCreate.no': '否',

  // 确认对话框
  'pages.service-config.confirm.ok': '确定',
  'pages.service-config.confirm.cancel': '取消',

  // 详情页面
  'pages.service-config.detail.page.title': '金额配置详情',
  'pages.service-config.detail.page.breadcrumb.config': '金额配置',
  'pages.service-config.detail.page.breadcrumb.detail': '详情',
  'pages.service-config.detail.table.title': '金额配置详情列表',
  'pages.service-config.detail.table.new': '新建',
  'pages.service-config.detail.table.confirmDelete': '确定要删除这条记录吗？',
  'pages.service-config.detail.table.batchDelete': '批量删除',
  'pages.service-config.detail.table.confirmBatchDelete': '确定要删除选中的 {count} 条记录吗？',
  'pages.service-config.detail.table.deleteSuccess': '删除成功',
  'pages.service-config.detail.table.batchDeleteSuccess': '批量删除成功',
  'pages.service-config.detail.table.deleteFailed': '删除失败',
  'pages.service-config.detail.table.batchDeleteFailed': '批量删除失败',
  'pages.service-config.detail.table.getDetailFailed': '获取详情失败',

  // 详情表格列
  'pages.service-config.detail.table.columns.feeType': '收费类型',
  'pages.service-config.detail.table.columns.name': '名称',
  'pages.service-config.detail.table.columns.unitPrice': '单价',
  'pages.service-config.detail.table.columns.unit': '单位',
  'pages.service-config.detail.table.columns.sort': '排序',
  'pages.service-config.detail.table.columns.billingCycle': '计费周期',
  'pages.service-config.detail.table.columns.status': '状态',
  'pages.service-config.detail.table.columns.batchCreate': '支持批量创建',
  'pages.service-config.detail.table.columns.createdTime': '创建时间',
  'pages.service-config.detail.table.columns.operations': '操作',
  'pages.service-config.detail.table.columns.edit': '编辑',
  'pages.service-config.detail.table.columns.delete': '删除',

  // 详情表单
  'pages.service-config.detail.form.editTitle': '编辑配置',
  'pages.service-config.detail.form.createTitle': '新建配置',
  'pages.service-config.detail.form.feeType.label': '收费类型',
  'pages.service-config.detail.form.feeType.required': '请选择收费类型',
  'pages.service-config.detail.form.feeType.placeholder': '请选择收费类型',
  'pages.service-config.detail.form.name.label': '名称',
  'pages.service-config.detail.form.name.required': '请输入名称',
  'pages.service-config.detail.form.name.placeholder': '请输入名称',
  'pages.service-config.detail.form.unitPrice.label': '单价',
  'pages.service-config.detail.form.unitPrice.required': '请输入单价',
  'pages.service-config.detail.form.unitPrice.placeholder': '请输入单价',
  'pages.service-config.detail.form.unitPrice.min': '单价不能小于0',
  'pages.service-config.detail.form.unit.label': '单位',
  'pages.service-config.detail.form.unit.required': '请输入单位',
  'pages.service-config.detail.form.unit.placeholder': '请输入单位，如：元/平方米、元/月等',
  'pages.service-config.detail.form.billingCycle.label': '计费周期',
  'pages.service-config.detail.form.billingCycle.required': '请选择计费周期',
  'pages.service-config.detail.form.billingCycle.placeholder': '请选择计费周期',
  'pages.service-config.detail.form.sort.label': '排序',
  'pages.service-config.detail.form.sort.required': '请输入排序值',
  'pages.service-config.detail.form.sort.placeholder': '请输入排序值',
  'pages.service-config.detail.form.sort.min': '排序值必须为非负数',
  'pages.service-config.detail.form.status.label': '状态',
  'pages.service-config.detail.form.status.required': '请选择状态',
  'pages.service-config.detail.form.status.placeholder': '请选择状态',
  'pages.service-config.detail.form.batchCreate.label': '是否支持批量创建',
  'pages.service-config.detail.form.batchCreate.required': '请选择是否支持批量创建',
  'pages.service-config.detail.form.updateSuccess': '更新成功',
  'pages.service-config.detail.form.createSuccess': '创建成功',
  'pages.service-config.detail.form.submitFailed': '提交失败',

  // 计费周期选项
  'pages.service-config.billingCycle.monthly': '按月',
  'pages.service-config.billingCycle.quarterly': '按季度',
  'pages.service-config.billingCycle.yearly': '按年',
  'pages.service-config.billingCycle.once': '一次性',
  'pages.service-config.billingCycle.daily': '按日',

  // 收费类型选项
  'pages.service-config.feeType.property_fee': '物业费',
  'pages.service-config.feeType.parking_fee': '停车费',
  'pages.service-config.feeType.water_fee': '水费',
  'pages.service-config.feeType.electricity_fee': '电费',
  'pages.service-config.feeType.gas_fee': '燃气费',
  'pages.service-config.feeType.heating_fee': '供暖费',
  'pages.service-config.feeType.maintenance_fee': '维修费',
  'pages.service-config.feeType.other': '其他',
};
